export const timing: string = '.5s ';
export const easing: string = 'cubic-bezier(.25, .8, .25, 1)';
